<template>
    <div id="myModal" class="modal-u" v-if="isVisibleModal">
        <div class="modal-u-content" :style=computed_modal_style>
            <div class="modal-u-header"
                :style="{ backgroundColor: (headerBgColor && (typeof headerBgColor !== 'undefined')) ? headerBgColor : 'transparent'}">
                <span class="close-u" @click="close()">&times;</span>
                <span class="header-txt"
                    :style="{ color: (headerColor && (typeof headerColor !== 'undefined')) ? headerColor : 'white'}">
                    {{ headerText }}
                </span>
            </div>
            <div class="modal-u-body">
                <slot></slot>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    name: "UniversalModal",
    props: {
        customWidth: {
            type: String
        },
        customHeight: {
            type: String
        },
        backgroundImage: {
            type: String
        },
        backgroundColor: {
            type: String
        },
        color: {
            type: String
        },
        size: {
            type: String
        },
        headerBgColor: {
            type: String,
        },
        headerColor: {
            type: String,
        },
        headerText: {
            type: String
        }
    },
    data() {
        return {
            sizeTypes: {
                'small': {
                    width: 350
                },
                'medium': {
                    width: 550
                },
                'large': {
                    width: 750
                },
            },
            isVisibleModal: false,
        }
    },
    created() {},
    computed: {
        computed_modal_style: function(){
            return {
                width: (this.size && (typeof this.size !== 'undefined')) ? this.sizeTypes[this.size].width+'px' : this.customWidth, 
                minHeight: (this.customHeight && (typeof this.customHeight !== 'undefined')) ? this.customHeight : 'auto',
                backgroundImage: (this.backgroundImage && (typeof this.backgroundImage !== 'undefined')) ? 'url('+require('../assets/img/'+this.backgroundImage)+')' : 'none'
            }
        },
    },
    methods: {
        show() {
            this.isVisibleModal = true;
            this.$emit('showed');
        },
        close() {
            this.isVisibleModal = false;
            this.$emit('closed');
        },
    },
}
</script>

<style>
.modal-u-header {
  padding: 2px 16px;
  color: white;
  height: 30px;
  border-radius: 0.15rem 0.15rem 0 0;
}

.modal-u-header > span.header-txt {
    color: white;
    font-size: 1rem;
    font-weight: 500;
}

.modal-u-body {
    padding: 2px 20px;
}

.modal-u {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999999999; /* Sit on top */
  padding-top: 5%; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0,0,0,0.74); /* Black w/ opacity */
}

.modal-u-content {
  position: relative;
  background-color: #fefefe;
  background-size: cover;
  background-repeat: none;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  animation-name: animatetop;
  animation-duration: 0.4s;
  border-radius: 0.25rem 0.25rem 0.15rem 0.15rem;
  margin-bottom: 40px;
}

.close-u {
  color: #3f3f3f;
  position: absolute;
  top: -8px;
  right: 10px;
  font-size: 28px;
  font-weight: bold;
}

.close-u:hover,
.close-u:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@keyframes animatetop {
  from {top: -300px; opacity: 0}
  to {top: 0; opacity: 1}
}

@media only screen and (max-width: 768px) {
    .modal-u-content {
        width: 90% !important;
        background-image: none !important;
        border: 2px solid #007bff;
    }
}
</style>
